import { LIMIT } from '@/constants';
import { fetchSearchHotWords, fetchSearchResult } from '@/services';
import { HotWordType, LoadMoreStatus, Sort, type AnyObj } from '@/types';
import type { Search } from '@/types/global-business';
import { defineStore } from 'pinia';

interface State {
  /** 搜索输入值 */
  searchValue: string;
  /** 自动聚焦标识 */
  autoFocusFlag: boolean;
  /** 搜索热词 */
  searchHotWords: Search.HotWord[];
  /** 搜索结果数据 */
  searchResult: AnyObj[];
  /** 搜索结果请求参数 */
  searchVariables: {
    skip: number;
    priceSort: Sort | null;
    saelsSort: Sort | null;
  };
  /** 搜索结果加载状态 */
  loadStatus: LoadMoreStatus;
}

export const useSearchStore = defineStore('search', {
  state: (): State => ({
    searchValue: '',
    autoFocusFlag: false,
    searchHotWords: [],
    searchResult: [],
    searchVariables: {
      skip: 0,
      priceSort: null,
      saelsSort: null,
    },
    loadStatus: LoadMoreStatus.loading,
  }),

  actions: {
    /** 获取搜索结果数据 */
    async getSearchResult(refresh?: boolean) {
      let variables: AnyObj = {
        options: {
          take: LIMIT,
          skip: LIMIT * this.searchVariables.skip,
          filter: {
            name: { contains: this.searchValue },
            hidden: { eq: false },
            freeGift: { eq: false },
          },
          sort: {
            createdAt: Sort.DESC,
          },
        },
      };

      if (this.searchVariables.priceSort && this.searchVariables.priceSort !== Sort.NONE) {
        variables.options = {
          ...variables.options,
          sort: { price: this.searchVariables.priceSort },
        };
      }

      if (this.searchVariables.saelsSort && this.searchVariables.saelsSort !== Sort.NONE) {
        variables.options = {
          ...variables.options,
          sort: { salesVolume: this.searchVariables.saelsSort },
        };
      }

      const data = await fetchSearchResult(variables);

      if (data) {
        if (data.length < LIMIT) {
          this.loadStatus = LoadMoreStatus.noMore;
        } else {
          this.loadStatus = LoadMoreStatus.more;
        }
        if (refresh) {
          this.searchResult = [...data];
        } else {
          this.searchResult = [...this.searchResult, ...data];
        }
      }

      return this.searchResult;
    },
    // 获取搜索热词
    async getSearchHotWords() {
      const data = await fetchSearchHotWords();
      if (data) {
        const d1 = data.filter((it: AnyObj) => it.type === HotWordType.choiceness);
        const d2 = data.filter((it: AnyObj) => it.type === HotWordType.ordinary);
        this.searchHotWords = [...d1, ...d2];
      }
    },
    resetSearchVariables() {
      this.searchVariables = {
        skip: 0,
        priceSort: null,
        saelsSort: null,
      };
    },
  },
});
